import { useState, useEffect } from "react"

const RenderOnlyOnClientSide = (props) => {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      setShouldRender(true)
      return
    }
  }, [])

  if (shouldRender) {
    return props.children
  }

  return <div />
}

export default RenderOnlyOnClientSide
